"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBCModule = void 0;
const tx_1 = require("../codec/ibc/applications/transfer/v1/tx");
const util_1 = require("../util");
const base_1 = __importDefault(require("./base"));
class IBCModule extends base_1.default {
    sendIBCTransfer(params, msgOpts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            if (!params.revisionHeight) {
                const lastHeight = yield this.sdkProvider.query.chain.getHeight();
                // Set the timeout height as the current height + 150.
                params.revisionHeight = (lastHeight !== null && lastHeight !== void 0 ? lastHeight : 0) + 150;
            }
            const value = tx_1.MsgTransfer.fromPartial(Object.assign({ sourcePort: params.sourcePort, sourceChannel: params.sourceChannel, token: {
                    denom: params.denom,
                    amount: params.amount.toString(10),
                }, sender: (_a = params.sender) !== null && _a !== void 0 ? _a : wallet.bech32Address, receiver: params.receiver, timeoutHeight: {
                    revisionHeight: params.revisionHeight,
                    revisionNumber: (_b = params.revisionNumber) !== null && _b !== void 0 ? _b : 1,
                } }, params.timeoutTimestamp && {
                timeoutTimestamp: params.timeoutTimestamp,
            }));
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgTransfer,
                value,
            }, msgOpts);
        });
    }
}
exports.IBCModule = IBCModule;
;
